const de = {
  title: 'Rechnungsdaten',
  tabs: {
    tax: 'Steuer',
    metadata: 'Rechnungsdaten',
    revenuetype: 'Erlös-Typ',
    department: 'Abteilungen / Fakultäten',
    article: 'Artikelstammdaten'
  },
  mutation: {
    taxCreationSuccess: 'Neue Steuer wurde erfolgreich angelegt.',
    taxCreationFailed: 'Beim Anlegen der Steuer ist ein Fehler aufgetreten.',
    taxUpdateSuccess: 'Neue Steuer wurde erfolgreich aktualisiert.',
    taxUpdateFailed: 'Beim Aktualisieren der Steuer ist ein Fehler aufgetreten.',
    metadataCreationSuccess: 'Neue Rechnungsdaten wurde erfolgreich angelegt.',
    metadataCreationFailed: 'Beim Anlegen der Rechnungsdaten ist ein Fehler aufgetreten.',
    metadataUpdateSuccess: 'Neue Rechnungsdaten wurde erfolgreich aktualisiert.',
    metadataUpdateFailed: 'Beim Aktualisieren der Rechnungsdaten ist ein Fehler aufgetreten.',
    revenueTypeCreationSuccess: 'Neuer Erlös-Typ wurde erfolgreich angelegt.',
    revenueTypeCreationFailed: 'Beim Anlegen des Erlös-Typs ist ein Fehler aufgetreten.',
    revenueTypeUpdateSuccess: 'Neuer Erlös-Typ wurde erfolgreich aktualisiert.',
    revenueTypeUpdateFailed: 'Beim Aktualisieren des Erlös-Typs ist ein Fehler aufgetreten.',
    articleUpdateSuccess: 'Der Artikel wurde erfolgreich aktualisiert.',
    articleUpdateFailed: 'Beim Aktualisieren des Artikels ist ein Fehler aufgetreten.',
    departmentCreationSuccess: 'Neue Abteilung wurde erfolgreich angelegt.',
    departmentCreationFailed: 'Beim Anlegen der Abteilung ist ein Fehler aufgetreten.',
    departmentUpdateSuccess: 'Abteilung wurde erfolgreich aktualisiert.',
    departmentUpdateFailed: 'Beim Aktualisieren der Abteilung ist ein Fehler aufgetreten.'
  },
  tax: {
    key: 'Schlüssel',
    text: 'Text',
    taxRate: 'Steuerrate',
    drawer: { create: 'Neue Steuer anlegen', update: 'Steuer aktualisieren' }
  },
  revenueType: {
    revenueTypeNumber: 'Erlös-Typ Nummer',
    drawer: { create: 'Neuen Erlös-Typ anlegen', update: 'Erlös-Typ aktualisieren' }
  },
  department: {
    name: 'Abteilungsname',
    toggleText: 'Zeige deaktivierte Abteilungen',
    drawer: {
      create: 'Neue Abteilung / Fakultät anlegen',
      update: 'Abteilung / Fakultät aktualisieren',
      info: 'Hier können Abteilungen und Fakultäten angelegt werden, welche bei der Rechnungserstellung ausgewählt werden können.',
      editHint:
        'Das Ändern des Abteilungsnamens kann die Suche nach bereits erstellten Rechnungen einschränken. Bei einer Umbenennung empfehlen wir, eine neue Abteilung anzulegen und die alte auf „deaktiviert“ zu setzen.'
    }
  },
  metadata: {
    key: 'Schlüssel',
    text: 'Text',
    drawer: { update: 'Rechnungsdaten aktualisieren' }
  },
  article: {
    sku: 'Artikelnummer',
    drawer: { update: 'Artikel aktualisieren' }
  },
  validation: {
    revenueType: 'Der Erlös-Typ muss eine Nummer sein.'
  }
};

export default de;
export type BillingSettingsTranslation = typeof de;
